import { useQueryClient } from "@tanstack/react-query";
import { leadApi } from "api/lead";
import { AssigneeSelect as SharedAssigneeSelect } from "shared/components/Assignee";

interface AssigneeSelectProps {
  value?: number | null;
  rowId?: string;
  inputClassName?: string;
  onChange?: (partner_user_id: number | null) => void;
  label?: string;
}

export const AssigneeSelect = ({
  value,
  rowId,
  inputClassName,
  onChange,
  label
}: AssigneeSelectProps) => {
  const queryClient = useQueryClient();

  const handleAssign = async (
    row_id: string,
    partner_user_id: number | null
  ) => {
    return leadApi.assignLead({
      lead_id: Number(row_id),
      partner_user_id
    });
  };

  const handleAssignSuccess = () => {
    queryClient.refetchQueries({ queryKey: ["LEAD_ACTIVITY_LOG"] });
    queryClient.refetchQueries({ queryKey: ["LEADS_TABLE"] });
    if (rowId) queryClient.refetchQueries({ queryKey: ["LEAD", rowId] });
  };

  return (
    <SharedAssigneeSelect
      value={value}
      rowId={rowId}
      inputClassName={inputClassName}
      onChange={onChange}
      onAssign={handleAssign}
      onAssignSuccess={handleAssignSuccess}
      label={label}
      successMessage="Lead assigned successfully"
      errorMessage="Failed to assign lead"
    />
  );
};
